module.exports = __webpack_public_path__ + "img/external-link.ac05cd4f.svg";